import Column from './Column'

export default class ColumnCollection extends Set {
  add(column) {
    // eslint-disable-next-line no-unsafe-negation
    if (!column instanceof Column) {
      throw Error('Invalid [Column] argument type. ')
    }

    super.add(column)
  }

  hasByProp(p, v) {
    const i = this.values()

    for (let item = i.next().value; item; item = i.next().value) {
      if (item[p] === v) {
        return true
      }
    }

    return false
  }
}
